<div class="p-5 rounded-xl max-w-screen-sm mx-auto">
  <div class="flex">
    <div [class.pr-4]="imgUrl">
      <p class="pb-2 font-accent font-bold text-1xsl leading-tight">
        {{ title }}
      </p>
      <p class="pb-5 font-accent text-base text-neutral-600 leading-tight">
        {{ text }}
      </p>
    </div>
    @if (imgUrl) {
      <div>
        <img
          class="min-w-16.5"
          src="{{ imgUrl }}"
          alt=""
        />
      </div>
    }
  </div>
  @if (!isSafari) {
    <div class="flex justify-center">
      <app-button-atom
        icon="icon-cross"
        [type]="'outlined'"
        [size]="'S'"
        color="neutral"
        label="Non"
        (clickEventEmitter)="noButtonClick.emit($event)"
      ></app-button-atom>
      <app-button-atom
        class="ml-6"
        icon="icon-check-single"
        [type]="'outlined'"
        [size]="'S'"
        color="neutral"
        label="Oui"
        (clickEventEmitter)="yesButtonClick.emit($event)"
      ></app-button-atom>
    </div>
  }
  @if (isSafari) {
    <div class="font-accent text-sm text-neutral-600 leading-tight">
      Appuyez <i class="icon-share-button"></i>, puis sur "Ajouter à l'écran d'accueil"
      @if (isSafari) {
        <div class="flex justify-center">
          <i class="icon icon-arrow-down-s icon-rotate-90 icon-32"></i>
        </div>
      }
    </div>
  }
</div>
